import { styled } from '@mui/material'

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'focused',
})<{
  focused?: boolean
}>(({ theme, focused }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  alignItems: 'center',
  padding: `${theme.spacing(1)}`,
  minHeight: '32px',
  borderRadius: theme.display.borderRadiusSmall,
  backgroundColor: focused ? `${theme.colours.primary}33` : 'white',
  '&:hover': {
    backgroundColor: `${theme.colours.primary}1A`,
    cursor: 'pointer',
    '& :not(span#CaseOverviewCaseType)': {
      color: theme.colours.primary,
    }
  },
  '&.Mui-focused.Mui-focusVisible': {
    backgroundColor: `${theme.colours.primary}33`,
    '& :not(span#CaseOverviewCaseType)': {
      color: theme.colours.primary,
    }
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
}))

export const BoxName = styled('div')(({ theme }) => ({
  color: theme.colours.base,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(14),
  marginRight: theme.spacing(1),
  lineHeight: 1.6,
  overflow: 'auto',
}))

export const BoxReason = styled('div')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(12),
  color: theme.colours.baseMid,
  padding: `0 ${theme.spacing(.5)}`,
}))

export const BoxDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  '.status-tag': {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(12),
    color: theme.colours.baseMid,
  },
  '.postcode': {
    width: '65px',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(11),
    color: theme.colours.baseMid,
    textAlign: 'right',
    textTransform: 'uppercase',
    padding: `0 ${theme.spacing(.5)}`,
  },
}))
